import { render, staticRenderFns } from "./CellRendererIcon.vue?vue&type=template&id=a464b740"
import script from "./CellRendererIcon.vue?vue&type=script&lang=js"
export * from "./CellRendererIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports